import { Colors, IColors } from './colors';
import { Font, IFont } from './fonts';
import { ISpace, Space } from './space';
import { breakpoints, shadow } from './tokens';
import { IBreakpoints } from './tokens/breakpoints';
import { IShadow } from './tokens/shadow';

interface ITheme {
  borderRadius: { xsmall: number; small: number; medium: number; large: number };
  breakpoint: IBreakpoints;
  button: { height: { large: number; small: number } };
  card: { minHeight: { large: number; small: number } };
  color: IColors;
  dropdown: { item: { height: { desktop: number; mobile: number } } };
  font: IFont;
  header: { height: number };
  input: { height: { large: number; small: number } };
  nav: { width: { closed: number; open: number } };
  shadow: IShadow;
  sidebar: { footer: { height: { large: number; medium: number; small: number } }; padding: number; width: { xlarge: number; large: number; small: string } };
  space: ISpace;
  table: { cell: { height: number }; label: { offset: number } };
  toast: { timing: number };
  transition: { button: { default: string; fast: string }; icon: string; nav: string; spring: { accordion: { type: string; damping: number; stiffness: number } } };
  user: { item: { height: number } };
  zIndex: { content: number; contentHeader: number; dialog: number; filter: number; header: number; modal: number; nav: number; banner: number; overlay: number; sidebar: number; toast: number };
}

const theme: ITheme = {
  borderRadius: {
    xsmall: 4,
    small: 11,
    medium: 16.5,
    large: 22,
  },
  breakpoint: {
    ...breakpoints,
  },
  button: {
    height: {
      large: 44,
      small: 33,
    },
  },
  card: {
    minHeight: {
      large: 110,
      small: 66,
    },
  },
  color: {
    ...Colors,
  },
  dropdown: {
    item: {
      height: {
        desktop: 33,
        mobile: 44,
      },
    },
  },
  font: {
    ...Font,
  },
  header: {
    height: 66,
  },
  input: {
    height: {
      large: 44,
      small: 35,
    },
  },
  nav: {
    width: {
      closed: 66,
      open: 244,
    },
  },
  shadow: { ...shadow },
  sidebar: {
    footer: {
      height: {
        large: 186,
        medium: 154,
        small: 88,
      },
    },
    padding: 33,
    width: {
      xlarge: 462,
      large: 400,
      small: '100%',
    },
  },
  space: {
    ...Space,
  },
  table: {
    cell: {
      height: 66,
    },
    label: {
      offset: 19,
    },
  },
  toast: {
    timing: 5000,
  },
  transition: {
    button: {
      default: 'ease-out 100ms',
      fast: 'ease-out 75ms',
    },
    icon: '100ms ease-in',
    nav: '225ms ease-out',
    spring: {
      accordion: {
        type: 'spring',
        damping: 40,
        stiffness: 500,
      },
    },
  },
  user: {
    item: {
      height: 66,
    },
  },
  zIndex: {
    content: 0,
    contentHeader: 100,
    dialog: 700,
    filter: 200,
    header: 600,
    modal: 800,
    banner: 500,
    nav: 500,
    overlay: 300,
    sidebar: 400,
    toast: 900,
  },
};

export default theme;
